exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\niframe[data-v-3b9aec20] {\n  height: 2800px;\n}\n@media (max-width: 842px) {\niframe[data-v-3b9aec20] {\n    height: 2800px;\n}\n}\n", ""]);

// exports
